import axios from 'axios';

export const state = {
  eieInvestments: [],
  totalElements: 0,
  createdCheckout: null,
  createdTransfer: null,
  nextToken: null,
  currPage: 0,
  loading: false,
};

export const mutations = {
  CLEAR_EIE_INVESTMENTS(context) {
    context.eieInvestments = [];
    context.currPage = 0;
    context.nextToken = null;
    context.totalElements = 0;
  },

  SET_EIE_INVESTMENTS(context, newInvestments) {
    const { elems, nextToken } = newInvestments;

    elems.forEach((investment) => {
      const index = context.eieInvestments.findIndex(item => item.id === investment.id);

      if (index === -1) {
        // Element not found in the array, add it
        context.eieInvestments.push(investment);
      } else {
        // Element found in the array, update it
        context.eieInvestments[index] = investment;
      }
    });

    context.nextToken = nextToken;
    context.totalElements = context.eieInvestments.length;
    context.numberOfPages = Math.ceil(context.totalElements / context);
  },

  SET_PAGINATION(context, page) {
    context.currPage = page;
  },

  SET_CANCELLING(context, id) {
    context.eieInvestments = context.eieInvestments.map(investment => (investment.id === id ? ({
      ...investment,
      status: 'cancelling',
    }) : investment));
  },

  SET_CREATED_CHECKOUT(context, newCheckout) {
    context.createdCheckout = newCheckout;
  },

  SET_CREATED_TRANSFER(context, newTransfer) {
    context.createdTransfer = newTransfer;
  },

  SET_LOADING(context, value) {
    context.loading = value;
  },
};


export const getters = {
  totalElements: currenctState => currenctState.totalElements,
  hasNextPage: currenctState => currenctState.nextToken !== undefined,
};

export const actions = {
  async clearEieInvestments({ commit, rootState }, params) {
    commit('CLEAR_EIE_INVESTMENTS');
  },

  async getEieInvestments({ commit, rootState }, params) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;

      const { currPage } = eieInvestmentsStore.state;
      const nextPage = params.page;
      const rowsPerPage = params.per_page;
      const { order } = params;
      const totalElements = eieInvestmentsStore.state.eieInvestments.length;
      const { nextToken } = eieInvestmentsStore.state;

      if (currPage !== 0 && (nextPage * rowsPerPage < totalElements || nextToken === undefined)) {
        return;
      }

      const options = {
        headers: {
          Authorization: jwtToken,
        },
        params: {
          pageSize: rowsPerPage,
          nextToken,
          order,
        },
      };

      if (params.userId) {
        options.params.userId = params.userId;
      }

      if (params.status) {
        options.params.status = params.status;
      }

      commit('SET_LOADING', true);

      const eieInvestments = await axios.get(`${window.BASE_API.MKI_ADMIN_BASE}/investments/list`, options)
        .then(response => response.data || []);

      commit('SET_EIE_INVESTMENTS', eieInvestments);
      commit('SET_PAGINATION', nextPage);
    } catch (err) {
      console.error(err);
    }
    commit('SET_LOADING', false);
  },

  async cancelInvestment({ commit, rootState }, id) {
    // eslint-disable-next-line no-console
    console.info('cancelInvestment for id: ', id);
    let result;
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      commit('SET_LOADING', true);

      result = await axios.post(`${window.BASE_API.MKI_ADMIN_BASE}/investments/cancel`, {
        id,
      }, {
        headers: {
          Authorization: jwtToken,
        },
      });

      commit('SET_CANCELLING', id);
    } catch (err) {
      console.error(err);
    }
    commit('SET_LOADING', false);

    return result;
  },

  async getSigningDocumentUrl({ commit, rootState }, requestData) {
    const { userId, id } = requestData;
    try {
      const response = await axios.get(`${window.BASE_API.MKI_ADMIN_BASE}/downloads/signingDocument/investment/${id}/user/${userId}`);

      return response.data;
    } catch (err) {
      console.error('Error downloading signing document', err);
      throw new Error(err);
    }
  },

  async downloadSurveyPdf({ commit, rootState }, requestData) {
    const { userId, createdAt } = requestData;
    try {
      const response = await axios.get(`${window.BASE_API.EXPLORATION}/exploration/pdf/user/${userId}/created/${createdAt}`);

      return {
        data: response.data,
        headers: response.headers,
      };
    } catch (err) {
      throw new Error(err);
    }
  },

  clearCheckoutResult({ commit }) {
    commit('SET_CREATED_CHECKOUT', null);
  },

  async createCheckout({ commit, rootState }, params) {
    console.info('createCheckout', params);

    try {
      const options = {
        headers: {
          Authorization: rootState.userStore.user.signInUserSession.idToken.jwtToken,
        },
      };

      commit('SET_LOADING', true);

      const result = await axios.post(`${window.BASE_API.EIE_ADMIN_BASE}/checkout/create`,
        { ...params, amount: parseInt(params.amount, 0) }, options)
        .then(response => response.data);

      commit('SET_CREATED_CHECKOUT', result);
    } catch (err) {
      console.error(err);
      commit('SET_LOADING', false);

      throw err;
    }
    commit('SET_LOADING', false);
  },

  clearTransferResult({ commit }) {
    commit('SET_CREATED_TRANSFER', null);
  },

  async createTransfer({ commit, rootState }, params) {
    console.info('createTransfer', params);

    try {
      const options = {
        headers: {
          Authorization: rootState.userStore.user.signInUserSession.idToken.jwtToken,
        },
      };

      commit('SET_LOADING', true);

      const result = await axios.post(`${window.BASE_API.TRADING_PLATFORM}/orderbook/status/trades/create-inheritance`,
        { ...params, amount: parseInt(params.pieces, 0) }, options)
        .then(response => response.data);

      commit('SET_CREATED_TRANSFER', result);
    } catch (err) {
      console.error(err);
      commit('SET_LOADING', false);

      throw err;
    }
    commit('SET_LOADING', false);
  },
};

const eieInvestmentsStore = {
  state,
  mutations,
  getters,
  actions,
};

export default eieInvestmentsStore;



// WEBPACK FOOTER //
// ./src/store/eieInvestments/eieInvestmentsStore.js